import React, { useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

function ScrollToTop({ history, children }) {
  useEffect(() => {
    const unlisten = history.listen(() => {
      let doc = document.getElementById("page");
      if(doc !== null)
        doc.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);
  return <Fragment>{children}</Fragment>;
}

export default withRouter(ScrollToTop);